import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a551df4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "concent" }
const _hoisted_2 = { class: "logout-box" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"title\" data-v-7a551df4> Terms &amp; Condition of Account Deactivation </div><div class=\"logout-content logout-bottom\" data-v-7a551df4><div class=\"logout-title\" data-v-7a551df4>Please Read Carefully</div><div class=\"logout-text\" data-v-7a551df4><p data-v-7a551df4> You are about to ask us to permanently close your Kilimall account and delete your data. Please note that there will be various consequences for your account cancellation, which may cause unrecoverable losses to you. Thus, please read the following instructions carefully and fully evaluate the consequences before submitting your request to close the account. At the same time, it is recommended to make adequate preparations before submitting such an application, such as making a backup of or completing the migration of those information and data saved under your account. </p><p class=\"text2\" data-v-7a551df4> Once your account is closed, all products and services that you access through your account will no longer be available, including but not limited to the following： </p><p class=\"text2 text-color\" data-v-7a551df4> 1. You will no longer be able to log in, and all login methods associated to the account will be removed, including Facebook and Google login. </p><p class=\"text2 text-color\" data-v-7a551df4> 2. All your transaction records will be cleared, so please make sure that all transactions have been completed and there are no disputes. After the account is closed, any rights and interests, such as returns and refunds-related rights, that may arise due to historical transactions will be deemed to be automatically waived. </p><p class=\"text2 text-color\" data-v-7a551df4> 3. Your identity information, account information, coupons, points, wallet balance, and other rights will be cleared and cannot be recovered, and you will not be able to access the very limited data or information kept by Kilimall in accordance with applicable law. </p><p data-v-7a551df4> Please take into consideration that your account will still be active while our customer relations teams are processing your request, but you cannot place an order or apply for after-sales service during this period. And the whole process of account closure may take up to 7 days from the date of submission of your request, while Kilimall reserves the right to extend the time limit for account closure or even not grant your request under certain circumstances, such as when there is a dispute associated with your account. </p></div></div>", 2)
const _hoisted_5 = { class: "logout-content-reason" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "reason-text" }, " Please select the main reason that is leading you to close your Kilimall account (non-mandatory) ", -1))
const _hoisted_7 = { class: "reason-checked" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" I Read and Agreed with the Terms & Condition Policies. ")
const _hoisted_9 = ["disabled"]
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Submit Application ")
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "popup-title" }, "Select the reason", -1))
const _hoisted_13 = { class: "popup-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_checkbox = _resolveComponent("van-checkbox")!
  const _component_van_radio = _resolveComponent("van-radio")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_radio_group = _resolveComponent("van-radio-group")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", {
          class: _normalizeClass(!$setup.reasonText ? 'reason-select' : 'reason-select-color'),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.handleReasonClick && $setup.handleReasonClick(...args)))
        }, [
          _createTextVNode(_toDisplayString($setup.reason) + " ", 1),
          _createVNode(_component_van_icon, { name: "arrow-down" })
        ], 2),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_van_checkbox, {
            modelValue: $setup.policiesChecked,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.policiesChecked) = $event)),
            shape: "square"
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("button", {
          class: _normalizeClass($setup.submitDisabled ? 'logout-button-disabled' : 'logout-button'),
          disabled: $setup.submitDisabled,
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.submitApplicationClick && $setup.submitApplicationClick(...args)))
        }, [
          _hoisted_10,
          ($setup.countTime > 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_11, "(" + _toDisplayString($setup.countTime) + "s)", 1))
            : _createCommentVNode("", true)
        ], 10, _hoisted_9)
      ])
    ]),
    _createVNode(_component_van_popup, {
      show: $setup.selectReasonShow,
      "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => (($setup.selectReasonShow) = $event)),
      position: "bottom",
      closeable: "",
      style: { height: '65%' }
    }, {
      default: _withCtx(() => [
        _hoisted_12,
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_van_radio_group, {
            modelValue: $setup.cancellationReason,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.cancellationReason) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_van_cell_group, { inset: "" }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.reasonList, (item) => {
                    return (_openBlock(), _createBlock(_component_van_cell, {
                      key: item.key,
                      title: item.label,
                      onClick: ($event: any) => ($setup.cancellationReasonClick(item)),
                      clickable: ""
                    }, {
                      "right-icon": _withCtx(() => [
                        _createVNode(_component_van_radio, {
                          name: item.key
                        }, null, 8, ["name"])
                      ]),
                      _: 2
                    }, 1032, ["title", "onClick"]))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}